/*
 * @Author: lyx
 * @Date: 2024-06 10:25:17
 * @LastEditTime: 2024-06 11:13:05
 * @FilePath: /dbrank_b/src/routes/visualChart/P27/chart.js
 */

import { axisLeft } from "d3";
import { toVisualThousands } from "../utils";
import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


function getChartsData(arr) {
  // console.log('arr',arr)
  let barData = [] // 折线图数据 x轴
  // 遍历数组中的每个子数组
  for (let index = 0; index < arr.length; index++) {
    //柱状图数据除以1百万
    const result = arr[index] / 100;
    var roundedResult = Math.round(result * 100) / 100;
    barData.push(Number(roundedResult));
  }
  return [barData]
}

export default ({ title, list = [], color = [], chartTitleText }) => {
    // var roundedResult = Math.round(result * 100) / 100;
    // barData.push(Number(roundedResult))
  let singleArr = getChartsData(list)
  return {
    title: {
      text: chartTitleText,
      textAlign: 'center',
      top: '0%',
      textStyle: {
        fontSize: '10px'
      }
    },
    legend: {
      show: false,
      top: '10%',
      bottom: 0,
      right: '4%',
      itemWidth: 10,
      itemHeight: 10
    },
    color,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '11%',
      right: 0,
      top: '40%',
      bottom: '-5',
      containLabel: false
    },
    xAxis: {
      show: false,
      type: 'category',
      data: title,
      // axisTick: {
      //   show: false
      // },
      axisLabel: { ...xAxisLabelColor, fontSize: '12px' },
    },
    yAxis: {
      show: true,
      type: 'value',
      // 数字品牌价值（单位：{db|DB}）
      name: '(单位：百万{db|DB})',
      splitLine: false,
      nameTextStyle: {
        fontSize: 10,
        color: '#000',
        padding: [0, 0, 0, -50],
        align: 'left',
        rich: {
          db: {
            fontSize: 10,
            fontStyle: 'italic'
          }
        },
      },
      axisLabel: { ...yAxisLabelColor,fontSize: '10px' },
    },
    series: [
      {
        name: `DB值`,
        type: 'bar',
        barWidth: '45%',
        label: {
          show: true,
          fontSize: '10px',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        data: singleArr[0]
        // data: [20, 19.21, 14.21, 11.2, 12.1, 10.56, 10.31, 10.1, 10.09, 9.66]
        // data: singleArr.map((item, index) => ({
        //   value: item,
        //   itemStyle: { color: color[index] },
        //   // label: { position: item == Math.max(...list) ? 'insideRight' : 'outside' }
        // })),
      }
    ]
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P27/chart.js